/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S9_Li2Inputs */

const tr_onbilgi_s9_li2 = /** @type {(inputs: Onbilgi_S9_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Mahkemeleri: Tüketici, davasını Sağlayıcı'nın yerleşim yerindeki (Antalya) tüketici mahkemesinde veya 6502 sayılı Kanun'un 73 üncü maddesinin beşinci fıkrası uyarınca kendi yerleşim yerindeki tüketici mahkemesinde açabilir; dava açılmadan önce, aynı Kanun'un 73/A maddesindeki istisnalar saklı kalmak üzere arabulucuya başvurulması zorunludur.`)
};

const en_onbilgi_s9_li2 = /** @type {(inputs: Onbilgi_S9_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consumer Courts: the consumer may bring the action before the consumer court at the Provider's seat (Antalya) or, under Article 73 paragraph 5 of Law No. 6502, before the consumer court at their own place of residence; before filing a lawsuit, an application to a mediator is mandatory under Article 73/A of the same Law, subject to the exceptions provided there.`)
};

const de_onbilgi_s9_li2 = /** @type {(inputs: Onbilgi_S9_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbrauchergerichte: Der Verbraucher kann seine Klage beim Verbrauchergericht am Sitz des Anbieters (Antalya) oder nach Artikel 73 Absatz 5 des Gesetzes Nr. 6502 beim Verbrauchergericht an seinem eigenen Wohnsitz erheben; vor Klageerhebung ist nach Artikel 73/A desselben Gesetzes, vorbehaltlich der dort geregelten Ausnahmen, ein Mediationsverfahren zwingend.`)
};

const ru_onbilgi_s9_li2 = /** @type {(inputs: Onbilgi_S9_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Суды по делам потребителей: потребитель может подать иск в суд по делам потребителей по месту нахождения Поставщика (Анталья) или, согласно части 5 статьи 73 Закона № 6502, в суд по делам потребителей по своему месту жительства; до подачи иска обязательно обращение к медиатору согласно статье 73/A того же Закона, за исключениями, предусмотренными законом.`)
};

/**
* | output |
* | --- |
* | "Consumer Courts: the consumer may bring the action before the consumer court at the Provider's seat (Antalya) or, under Article 73 paragraph 5 of Law No. 650..." |
*
* @param {Onbilgi_S9_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s9_li2 = /** @type {((inputs?: Onbilgi_S9_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S9_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s9_li2(inputs)
	if (locale === "de") return de_onbilgi_s9_li2(inputs)
	if (locale === "ru") return ru_onbilgi_s9_li2(inputs)
	return tr_onbilgi_s9_li2(inputs)
});